import React, {
    forwardRef,
    HTMLAttributes,
    MouseEvent,
    MouseEventHandler,
    useCallback,
} from "react";
import styled from "@emotion/styled";

import { ScrollbarStyles } from "../styles/scrollbar.styles";

const StyledContainer = styled.div(
    {
        margin: 0,
        padding: `0.375rem`,
        backgroundColor: `var(--formant-color-primary-dark)`,
        border: `1px solid var(--formant-color-highlights-blue)`,
        borderRadius: `0.25rem`,
        boxSizing: `border-box`,
        display: `flex`,
        flexDirection: `column`,
        minWidth: `16rem`,
        gap: `1px`,
        overflowX: "hidden",
        overflowY: "auto",
    },
    ScrollbarStyles,
    {
        "::-webkit-scrollbar-thumb": {
            borderTopRightRadius: `0.25rem`,
            borderBottomRightRadius: `0.25rem`,
        },
    },
);

interface IContainerProps {
    onItemClicked?: MouseEventHandler<HTMLDivElement>;
}

export const Container = forwardRef<
    HTMLDivElement,
    IContainerProps & HTMLAttributes<HTMLDivElement>
>(function Container(props, ref) {
    const { onItemClicked, onClick, children, ...rest } = props;
    const handleClick = useCallback(
        (e: MouseEvent<HTMLDivElement>) => {
            onClick?.(e);
            if (e.isPropagationStopped()) {
                return;
            }

            if (!(e.target instanceof HTMLElement)) {
                return;
            }

            let el: HTMLElement | null = e.target;
            while (
                el &&
                el instanceof Element &&
                e.currentTarget.contains(el)
            ) {
                if (el instanceof HTMLButtonElement && !el.disabled) {
                    onItemClicked?.(e);
                    break;
                }
                el = el.parentElement;
            }
        },
        [onClick, onItemClicked],
    );
    return (
        <StyledContainer {...rest} ref={ref} onClick={handleClick}>
            {children}
        </StyledContainer>
    );
});

Container.displayName = "Menu.Container";
